import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';

@Component({
  tag: 'wb-grid',
  styleUrl: 'grid.scss',
  shadow: true,
})
export class GridComponent implements ComponentInterface {
  /** attribute for a full-width grid */
  @Prop({ reflect: true })
  public fullWidth?: boolean = false;

  public render(): JSX.Element {
    return (
      <Host>
        <slot />
      </Host>
    );
  }
}
